import React from "react";
import { IonCard, IonLabel, IonImg, IonRouterLink } from "@ionic/react";
import styles from "./ThemeCard.module.css";

interface ThemeCardProps {
  title: string;
  imgSrc: string;
}

export const ThemeCard: React.FC<ThemeCardProps> = ({ title, imgSrc }) => {
  return (
    <IonCard className={styles.container}>
      <IonRouterLink href={`themes/${title}`}>
        <IonImg src={imgSrc} className={styles.backgroundImage} />
        <IonLabel className={styles.title}>{title}</IonLabel>
      </IonRouterLink>
    </IonCard>
  );
};
